import { render, staticRenderFns } from "./MassUpdateModel.vue?vue&type=template&id=d9bf6dd8&"
import script from "./MassUpdateModel.vue?vue&type=script&lang=js&"
export * from "./MassUpdateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports